import { render, staticRenderFns } from "./purchasenotice.vue?vue&type=template&id=7bc10496"
import script from "./purchasenotice.vue?vue&type=script&lang=js"
export * from "./purchasenotice.vue?vue&type=script&lang=js"
import style0 from "./purchasenotice.vue?vue&type=style&index=0&id=7bc10496&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports